import React from 'react';
import { Box, Flex, Text, Badge, Icon, HStack, Tooltip } from '@chakra-ui/react';
import { User, FileText, ShoppingCart, File, Receipt } from 'phosphor-react';
import { ISaidaImport } from '../../hooks/useCompanies';

interface ManualPostingsCardProps {
  item: ISaidaImport;
  // eslint-disable-next-line no-unused-vars
  onClick: (item: ISaidaImport) => void;
}

export function ManualPostingsCard({ item, onClick }: ManualPostingsCardProps) {
  const quantityFatura = item.quantity_fatura ?? 0;
  const total =
    item.quantity_total ??
    item.quantity_nfe + item.quantity_nfce + item.quantity_nfse + quantityFatura;

  return (
    <Box
      bg="white"
      borderRadius="xl"
      border="1px"
      borderColor="gray.200"
      p={4}
      cursor="pointer"
      transition="all 0.2s"
      _hover={{
        borderColor: 'blue.300',
        boxShadow: 'md',
        transform: 'translateY(-2px)',
      }}
      onClick={() => onClick(item)}
    >
      {/* Header: Badge de total */}
      <Flex justify="flex-end" mb={3}>
        <Badge colorScheme="blue" fontSize="xs" borderRadius="full" px={2}>
          {total} {total === 1 ? 'nota' : 'notas'}
        </Badge>
      </Flex>

      {/* Nome do Usuário */}
      <Flex align="center" gap={2} mb={2}>
        <Icon as={User} color="blue.500" boxSize={5} />
        <Text fontSize="md" fontWeight="semibold" color="gray.800" noOfLines={2}>
          {item.name}
        </Text>
      </Flex>

      {/* Origem */}
      <Text fontSize="sm" color="gray.500" mb={3}>
        Origem: {item.origin}
      </Text>

      {/* Quantidades de Notas */}
      <Box bg="gray.50" borderRadius="lg" p={3}>
        <HStack spacing={4} justify="space-around">
          <Tooltip label="Notas NFE">
            <Flex align="center" gap={2} direction="column">
              <Flex align="center" gap={1}>
                <Icon as={FileText} color="green.500" boxSize={4} weight="duotone" />
                <Text fontSize="xs" color="gray.500" fontWeight="medium">
                  NFE
                </Text>
              </Flex>
              <Text fontSize="lg" color="green.600" fontWeight="bold">
                {item.quantity_nfe.toLocaleString('pt-BR')}
              </Text>
            </Flex>
          </Tooltip>

          <Tooltip label="Notas NFCE">
            <Flex align="center" gap={2} direction="column">
              <Flex align="center" gap={1}>
                <Icon as={ShoppingCart} color="orange.500" boxSize={4} weight="duotone" />
                <Text fontSize="xs" color="gray.500" fontWeight="medium">
                  NFCE
                </Text>
              </Flex>
              <Text fontSize="lg" color="orange.600" fontWeight="bold">
                {item.quantity_nfce.toLocaleString('pt-BR')}
              </Text>
            </Flex>
          </Tooltip>

          <Tooltip label="Notas NFSE">
            <Flex align="center" gap={2} direction="column">
              <Flex align="center" gap={1}>
                <Icon as={File} color="purple.500" boxSize={4} weight="duotone" />
                <Text fontSize="xs" color="gray.500" fontWeight="medium">
                  NFSE
                </Text>
              </Flex>
              <Text fontSize="lg" color="purple.600" fontWeight="bold">
                {item.quantity_nfse.toLocaleString('pt-BR')}
              </Text>
            </Flex>
          </Tooltip>

          <Tooltip label="Notas de Fatura">
            <Flex align="center" gap={2} direction="column">
              <Flex align="center" gap={1}>
                <Icon as={Receipt} color="cyan.500" boxSize={4} weight="duotone" />
                <Text fontSize="xs" color="gray.500" fontWeight="medium">
                  Fatura
                </Text>
              </Flex>
              <Text fontSize="lg" color="cyan.600" fontWeight="bold">
                {quantityFatura.toLocaleString('pt-BR')}
              </Text>
            </Flex>
          </Tooltip>
        </HStack>
      </Box>

      {/* Total */}
      <Flex justify="center" mt={3}>
        <Badge colorScheme="gray" fontSize="sm" px={3} py={1} borderRadius="md">
          Total: {total.toLocaleString('pt-BR')}
        </Badge>
      </Flex>
    </Box>
  );
}
